export interface PieSliceData {
  value: number
  name: string
}

export interface PieChartRateData {
  complement: number
  slices: PieSliceData[]
}

export function calculatePieChartRate(
  rate: number,
  mainLabel: string,
  complementLabel: string
): PieChartRateData {
  const complement = 1 - rate

  const slices: PieSliceData[] =
    rate < 0
      ? [
          {
            value: complement,
            name: complementLabel,
          },
        ]
      : [
          {
            value: rate,
            name: mainLabel,
          },
          {
            value: complement,
            name: complementLabel,
          },
        ]

  return {
    complement,
    slices,
  }
}
